import React, { useState, useEffect, useRef } from 'react';
import './css/EquityPoolBlock.css';
import { formatNumberWithCommas } from './formatIntegerWithCommas.js';
import styled, { keyframes } from 'styled-components';
import { AiOutlineRight } from 'react-icons/ai';
import { t } from 'ttag';

const VerticalProgressBarContainer = styled.div`
  width: 60px;
  height: 100%;
  background-color:rgb(250 250 250 / 17%);
  position: relative;
  overflow: hidden;
`;

const getColor = (ssr) => {
  var clr = ["#52a84d99"]
  if (ssr > 30) clr = ["#ffde3399"]
  if (ssr > 70) clr = ["#d2404e99"]
  return clr;

}
const stripesAnimation = keyframes`
  0% { background-position: 0 0; }
  100% { background-position: 20px 0px; }
`;

const VerticalProgressBarFill = styled.div`
  position: absolute;
  bottom: 0;
  left: 0;
  width: 100%; /* Wider at the top */
  height: ${({ progress }) => `${progress}%`};
  transition: height 0.8s ease-out, width 0.8s ease; /* Animate width too */
  background: ${({ progress }) => `${getColor(progress)}`};
  /* Add a transform origin for scaling */
    background-image: linear-gradient(
    45deg,
    rgba(255, 255, 255, 0.15) 25%,
    transparent 25%,
    transparent 50%,
    rgba(255, 255, 255, 0.15) 50%,
    rgba(255, 255, 255, 0.15) 75%,
    transparent 75%,
    transparent
  );
  background-size: 20px 20px;
  animation: ${stripesAnimation} 1s linear infinite;
  transform-origin: bottom left;
`;



const VerticalProgressBarLabel = styled.div`
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 14px;
  color: #333;
`;

const VerticalProgressBar = ({ value, max }) => {
  const [progress, setProgress] = useState(0);
  const [animating, setAnimating] = useState(true);
  const animationTimeout = useRef(null);

  useEffect(() => {
    if (animating && max > 0) {
      setProgress(100); // Сначала до максимума
      animationTimeout.current = setTimeout(() => {
        setProgress(Math.min((value / max) * 100, 100));
        setAnimating(false);
      }, 800); // Задержка перед возвратом к реальному значению (настройте по желанию)
    } else if (!animating && max > 0) {
      setProgress(Math.min((value / max) * 100, 100));
    } else {
      setProgress(0);
    }

    return () => clearTimeout(animationTimeout.current); // Очистка таймаута при размонтировании
  }, [value, max, animating]);

  return (
    <VerticalProgressBarContainer>
      <VerticalProgressBarFill progress={progress} />

    </VerticalProgressBarContainer>
  );
};

function EquityPoolBlock({ equity_pool, ep_paid, round, price_after, round_sell, roundalocatoin }) {
  return (
    <div className="equity-pool-block">
      <div style={{ display: "flex" }}>

        <div className="equity-pool-pb">
          <div className="equity-pool-round">{t`Round`} {round}</div>
          <VerticalProgressBar value={round_sell} max={roundalocatoin} />
        </div>

        <div className="equity-pool-ol">
          <AiOutlineRight preserveAspectRatio={"none"} />
        </div>

        <div style={{ width: "calc(50% - 6px)" }}>
          <div className="equity-pool-round">{t`Round`} {round + 1}</div>
          <div className="equity-pool-info">
            {t`Equity pool`}
            <span>{formatNumberWithCommas(equity_pool,2)} USDT</span>
          </div>
          <div className="equity-pool-info">
            {t`Already paid`}
            <span>{formatNumberWithCommas(ep_paid,2)} USDT</span>
          </div>
          <div className="equity-pool-info">
            {t`Token price`}
            <span>{formatNumberWithCommas(price_after)} USDT</span>
          </div>
        </div>

      </div>
    </div>
  );
}

export { EquityPoolBlock };